<div class="box">
    <p-card>
        <form [formGroup]="form" (ngSubmit)="send()">
            <h1>Nueva entidad</h1>
            <p>Ingrese los datos solicitados en el siguiente formulario. Alguna documentacion electronica sera requerida
                para algunos campos</p>
            <div class="p-fluid">
                <div class="p-field p-grid">
                    <div class="p-col-12 p-md-12">
                        <p-dropdown formControlName="tipoEntidad" placeholder="Seleccionar tipo de entidad"
                            [options]="tiposEntidades"
                            [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                            optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                        <small *ngIf="form.get('tipoEntidad')?.hasError('required') && form.get('tipoEntidad')?.touched"
                            class="error">El campo es requerido</small>
                    </div>
                </div>
                <div formGroupName="entidadForm">
                    <div *ngIf="perNat">
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input formControlName="dui" type="text" placeholder="Ingrese su DUI" pInputText>
                                </span>
                                <small
                                    *ngIf="form.get('entidadForm.dui')?.hasError('required') && form.get('entidadForm.dui')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <span class="p-input-icon-right">
                                    <i class="pi pi-spin pi-spinner" *ngIf="duiLoading"></i>
                                    <input formControlName="nombre" type="text" placeholder="Nombres" pInputText>
                                </span>
                                <small
                                    *ngIf="form.get('entidadForm.nombre')?.hasError('required') && form.get('entidadForm.nombre')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <input formControlName="correo" type="email" placeholder="Ingrese su correo" pInputText>
                                <small
                                    *ngIf="form.get('entidadForm.correo')?.hasError('required') && form.get('entidadForm.correo')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-fileUpload url=" ./upload" chooseLabel="Adjunte DUI" accept="image/*" maxFileSize="1000000"
                                    (onSelect)="onFileSelected($event, 'imgDui')"></p-fileUpload>
                                <small
                                    *ngIf="form.get('entidadForm.imgDui')?.hasError('required') && form.get('entidadForm.imgDui')?.touched"
                                    class="error">El
                                    campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                            <p-dropdown formControlName="Natdepartamento" placeholder="Seleccionar departamento"
                            [options]="departamentos"
                            [(ngModel)]="departamento"
                            [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                            optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                                <small
                                    *ngIf="form.get('entidadForm.Natdepartamento')?.hasError('required') && form.get('entidadForm.Natdepartamento')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-dropdown formControlName="Natmunicipio" [(ngModel)]="municipio" placeholder="Seleccionar municipio"
                                [options]="municipios"
                                [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                                optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                                <small
                                    *ngIf="form.get('entidadForm.Natmunicipio')?.hasError('required') && form.get('entidadForm.Natmunicipio')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <textarea formControlName="direccion" rows="5" cols="30" placeholder="Ingrese su direccion"
                                    pInputTextarea autoResize="autoResize"></textarea>
                                <small
                                    *ngIf="form.get('entidadForm.direccion')?.hasError('required') && form.get('entidadForm.direccion')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-dropdown formControlName="tipoComprobante"
                                    placeholder="Tipo de comprobante predeterminado" [options]="tiposComprobantes"
                                    [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                                    optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                                <small
                                    *ngIf="form.get('entidadForm.tipoComprobante')?.hasError('required') && form.get('entidadForm.tipoComprobante')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <h1>Información de contacto</h1>
                        <p>El nombre de contacto debe de ser igual a la persona natural registrada, de ser una persona
                            jurídica
                            debe de ingresar el nombre del representante legal, si ingresa el nombre de una tercera persona,
                            debera seleccionar, en la última pregunta la opción “consultor” y llenar los datos solicitados.
                        </p>
                        <div formGroupName="infoJuridico">
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <input formControlName="nombres" type="text" placeholder="Ingrese sus nombres"
                                        pInputText>
                                    <small
                                        *ngIf="form.get('entidadForm.infoJuridico.nombres')?.hasError('required') && form.get('entidadForm.infoJuridico.nombres')?.touched"
                                        class="error">El campo es requerido</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <input formControlName="apellidos" type="text" placeholder="Ingrese sus apellidos"
                                        pInputText>
                                    <small
                                        *ngIf="form.get('entidadForm.infoJuridico.apellidos')?.hasError('required') && form.get('entidadForm.infoJuridico.apellidos')?.touched"
                                        class="error">El campo es requerido</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <p-inputMask placeholder="Ingrese su numero de teléfono" formControlName="telefono"
                                        mask="9999-9999"></p-inputMask>
                                    <small
                                        *ngIf="form.get('entidadForm.infoJuridico.telefono')?.hasError('required') && form.get('entidadForm.infoJuridico.telefono')?.touched"
                                        class="error">El campo es requerido</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <p-inputMask placeholder="Ingrese su numero celular" formControlName="celular"
                                        mask="9999-9999"></p-inputMask>
                                    <small
                                        *ngIf="form.get('entidadForm.infoJuridico.celular')?.hasError('required') && form.get('entidadForm.infoJuridico.celular')?.touched"
                                        class="error">El campo es requerido</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <input formControlName="correoC" type="email" placeholder="Ingrese su correo"
                                        pInputText>
                                    <small
                                        *ngIf="form.get('entidadForm.infoJuridico.correoC')?.hasError('required') && form.get('entidadForm.infoJuridico.correoC')?.touched"
                                        class="error">El campo es requerido</small>
                                </div>
                            </div>
                        </div>
                        <h1>Relación con el titular</h1>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-dropdown formControlName="relacion" placeholder="Especifique su relación con el Titular"
                                    [options]="relacionTitular" optionLabel="label" optionValue="value"></p-dropdown>
                                <small
                                    *ngIf="form.get('entidadForm.relacion')?.hasError('required') && form.get('entidadForm.relacion')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div *ngIf="consultor" formGroupName="relacionTitular">
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input formControlName="duiT" type="text" placeholder="Ingrese su DUI" pInputText>
                                    </span>
                                    <small
                                        *ngIf="form.get('entidadForm.relacionTitular.duiT')?.hasError('required') && form.get('entidadForm.relacionTitular.duiT')?.touched"
                                        class="error">El campo es requerido</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <span class="p-input-icon-right">
                                        <i class="pi pi-spin pi-spinner" *ngIf="duiTLoading"></i>
                                        <input formControlName="nombres" type="text" placeholder="Nombres"
                                            pInputText>
                                    </span>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <span class="p-input-icon-right">
                                        <i class="pi pi-spin pi-spinner" *ngIf="duiTLoading"></i>
                                        <input formControlName="apellidos" type="text" placeholder="Apellidos"
                                            pInputText>
                                    </span>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <!-- formControlName="addDui" -->
                                    <p-fileUpload url="./upload" chooseLabel="Adjunte DUI" accept="image/*" maxFileSize="1000000"
                                    (onSelect)="onFileSelected($event, 'addDui')"></p-fileUpload>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                     <!-- formControlName="addNota" -->
                                    <p-fileUpload url="./upload" chooseLabel="Adjunte nota de autorización" accept="image/*" maxFileSize="1000000"
                                    (onSelect)="onFileSelected($event, 'addNota')"></p-fileUpload>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <p-inputMask placeholder="Ingrese su numero de teléfono" formControlName="telefonoT"
                                        mask="9999-9999"></p-inputMask>
                                    <small
                                        *ngIf="form.get('natural.relacionTitular.telefonoT')?.hasError('required') && form.get('natural.relacionTitular.telefonoT')?.touched"
                                        class="error">El campo es requerido</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <p-inputMask placeholder="Ingrese su numero celular" formControlName="celularT"
                                        mask="9999-9999"></p-inputMask>
                                    <small
                                        *ngIf="form.get('entidadForm.relacionTitular.celularT')?.hasError('required') && form.get('entidadForm.relacionTitular.celularT')?.touched"
                                        class="error">El campo es requerido</small>
                                </div>
                            </div>
                            <div class="p-field p-grid">
                                <div class="p-col-12 p-md-12">
                                    <input formControlName="correoRe" type="email" placeholder="Ingrese correo" pInputText>
                                    <small
                                        *ngIf="form.get('entidadForm.relacionTitular.correoRe')?.hasError('required') && form.get('entidadForm.relacionTitular.correoRe')?.touched"
                                        class="error">El campo es requerido</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="perJuri">
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <span class="p-input-icon-left">
                                    <i class="pi pi-search"></i>
                                    <input formControlName="nit" type="text" placeholder="Ingrese su NIT" pInputText>
                                </span>
                                <small
                                    *ngIf="form.get('entidadForm.nit')?.hasError('required') && form.get('entidadForm.nit')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <input formControlName="nombreEntidad" type="text" placeholder="Nombre de la entidad"
                                    pInputText>
                                <small
                                    *ngIf="form.get('entidadForm.nombreEntidad')?.hasError('required') && form.get('entidadForm.nombreEntidad')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <input formControlName="correo" type="email" placeholder="Ingrese su correo" pInputText>
                                <small
                                    *ngIf="form.get('entidadForm.correo')?.hasError('required') && form.get('entidadForm.correo')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <!-- formControlName="imgNit" -->
                                <p-fileUpload url="./upload" chooseLabel="Adjunte NIT" accept="image/*" maxFileSize="1000000"
                                (onSelect)="onFileSelected($event, 'imgNit')"></p-fileUpload>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <!-- formControlName="escritura" -->
                                <p-fileUpload url="./upload" chooseLabel="Adjunte escritura de constitución" accept="image/*" maxFileSize="1000000"
                                (onSelect)="onFileSelected($event, 'escritura')"></p-fileUpload>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <!-- formControlName="modificacionConst" -->
                                <p-fileUpload url="./upload" chooseLabel="Adjunte modificación de constitución 
                                (si la hubiese)" accept="image/*" maxFileSize="1000000"
                                (onSelect)="onFileSelected($event, 'modificacionConst')"></p-fileUpload>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-dropdown formControlName="departamento" placeholder="Seleccionar departamento"
                                [options]="departamentos"
                                [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                                optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                                <small
                                    *ngIf="form.get('entidadForm.departamento')?.hasError('required') && form.get('entidadForm.departamento')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-dropdown formControlName="municipio" placeholder="Seleccionar municipio"
                                [options]="municipios"
                                [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                                optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                                <small
                                    *ngIf="form.get('entidadForm.municipio')?.hasError('required') && form.get('entidadForm.municipio')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <textarea formControlName="direccion" rows="5" cols="30" placeholder="Ingrese su direccion"
                                    pInputTextarea autoResize="autoResize"></textarea>
                                <small
                                    *ngIf="form.get('entidadForm.direccion')?.hasError('required') && form.get('entidadForm.direccion')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-dropdown formControlName="tipoComprobante"
                                    placeholder="Tipo de comprobante predeterminado" [options]="tiposComprobantes"
                                    [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                                    optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                                <small
                                    *ngIf="form.get('entidadForm.tipoComprobante')?.hasError('required') && form.get('entidadForm.tipoComprobante')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <h2>Representante legal</h2>
                        <hr>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <div class="p-formgroup-inline">
                                    <div class="p-field-radiobutton">
                                        <input type="radio" class="radioButton" name="representante" value="salva"
                                            formControlName="representante" pRadioButton>
                                        <label class="radioLabel" for="">Salvadoreño</label>
                                    </div>
                                    <div class="p-field-radiobutton">
                                        <input type="radio" class="radioButton" name="representante" value="extra"
                                            formControlName="representante" pRadioButton>
                                        <label class="radioLabel" for="">Extranjero</label>
                                    </div>
                                </div>
                            </div>
                            <!-- <small
                                    *ngIf="form.get('entidadForm.tipoComprobante')?.hasError('required') && form.get('entidadForm.tipoComprobante')?.touched"
                                    class="error">El campo es requerido</small> -->
                        </div>
                        <div *ngIf="salva">
                            <div formGroupName="salvadorenio">
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <span class="p-input-icon-left">
                                            <i class="pi pi-search"></i>
                                            <input formControlName="dui" type="text" placeholder="Ingrese su DUI" pInputText>
                                        </span>
                                        <small
                                            *ngIf="form.get('entidadForm.salvadorenio.dui')?.hasError('required') && form.get('entidadForm.salvadorenio.dui')?.touched"
                                            class="error">El campo es requerido</small>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <span class="p-input-icon-right">
                                            <i class="pi pi-spin pi-spinner" *ngIf="duiJLoading"></i>
                                            <input formControlName="nombres" type="text" placeholder="Nombres"
                                                pInputText>
                                        </span>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <span class="p-input-icon-right">
                                            <i class="pi pi-spin pi-spinner" *ngIf="duiJLoading"></i>
                                            <input formControlName="apellidos" type="text" placeholder="Apellidos"
                                            pInputText>
                                        </span>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <!-- formControlName="addDui" -->
                                        <p-fileUpload url="./upload" chooseLabel="Adjunte DUI" accept="image/*" maxFileSize="1000000"
                                        (onSelect)="onFileSelected($event, 'adjDui')"></p-fileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <!-- formControlName="addNota" -->
                                        <p-fileUpload url="./upload" chooseLabel="Adjunte credencial" accept="image/*" maxFileSize="1000000"
                                        (onSelect)="onFileSelected($event, 'adjCredencial')"></p-fileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <p-calendar [showIcon]="true" placeholder="Credencial vigente hasta" inputId="icon"
                                            formControlName="dateCredencial"></p-calendar>
                                        <small *ngIf="form.get('entidadForm.salvadorenio.dateCredencial')?.hasError('required') && form.get('entidadForm.salvadorenio.dateCredencial')?.touched"
                                            class="error">El
                                            campo es requerido</small>
                                    </div>
                                </div>
                                <h1>Apoderado</h1>
                                <hr>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <p-dropdown formControlName="hasApoderado"
                                            placeholder="Posee apoderado"[options]="hasApoderado"
                                            [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                                            optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                                        <small
                                            *ngIf="form.get('entidadForm.salvadorenio.hasApoderado')?.hasError('required') && form.get('entidadForm.salvadorenio.hasApoderado')?.touched"
                                            class="error">El campo es requerido</small>
                                    </div>
                                </div>
                                <div class="p-mt-5" *ngIf="apoderado" formGroupName="apoderado">
                                    <div class="p-field p-grid">
                                        <div class="p-col-12 p-md-12">
                                            <span class="p-input-icon-left">
                                                <i class="pi pi-search"></i>
                                                <input formControlName="duiA" type="text" placeholder="Ingrese su DUI" pInputText>
                                            </span>
                                            <small
                                                *ngIf="form.get('entidadForm.salvadorenio.apoderado.duiA')?.hasError('required') && form.get('entidadForm.salvadorenio.apoderado.duiA')?.touched"
                                                class="error">El campo es requerido</small>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <div class="p-col-12 p-md-12">
                                            <span class="p-input-icon-right">
                                                <i class="pi pi-spin pi-spinner" *ngIf="duiALoading"></i>
                                                <input formControlName="nombresA" type="text" placeholder="Nombres"
                                                    pInputText>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <div class="p-col-12 p-md-12">
                                            <span class="p-input-icon-right">
                                                <i class="pi pi-spin pi-spinner" *ngIf="duiALoading"></i>
                                                <input formControlName="apellidosA" type="text" placeholder="Apellidos"
                                                    pInputText>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <div class="p-col-12 p-md-12">
                                            <!-- formControlName="addDui" -->
                                            <p-fileUpload url="./upload" chooseLabel="Adjunte DUI" accept="image/*" maxFileSize="1000000"
                                            (onSelect)="onFileSelected($event, 'adjDuiA')"></p-fileUpload>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <div class="p-col-12 p-md-12">
                                            <input formControlName="tipoPoder" type="text" placeholder="Describe tipo de poder" pInputText>
                                            <small
                                                *ngIf="form.get('entidadForm.salvadorenio.apoderado.tipoPoder')?.hasError('required') && form.get('entidadForm.salvadorenio.apoderado.tipoPoder')?.touched"
                                                class="error">El campo es requerido</small>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <div class="p-col-12 p-md-12">
                                            <!-- formControlName="addDui" -->
                                            <p-fileUpload url="./upload" chooseLabel="Adjunte poder" accept="image/*" maxFileSize="1000000"
                                            (onSelect)="onFileSelected($event, 'adjPoder')"></p-fileUpload>
                                        </div>
                                    </div>
                                    <div class="p-field p-grid">
                                        <div class="p-col-12 p-md-12">
                                            <p-calendar [showIcon]="true" placeholder="Vigencia de poder hasta" inputId="icon"
                                                formControlName="datePoder"></p-calendar>
                                            <small *ngIf="form.get('entidadForm.salvadorenio.apoderado.datePoder')?.hasError('required') && form.get('entidadForm.salvadorenio.apoderado.datePoder')?.touched"
                                                class="error">El
                                                campo es requerido</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="extra">
                            <div formGroupName="extranjero">
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <span class="p-input-icon-left">
                                            <i class="pi pi-search"></i>
                                            <input formControlName="pasaporte" type="text" placeholder="Ingrese su Pasaporte" pInputText>
                                        </span>
                                        <small
                                            *ngIf="form.get('entidadForm.extranjero.pasaporte')?.hasError('required') && form.get('entidadForm.extranjero.pasaporte')?.touched"
                                            class="error">El campo es requerido</small>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <input formControlName="nombres" type="text" placeholder="Nombres"
                                            pInputText>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <input formControlName="apellidos" type="text" placeholder="Apellidos"
                                            pInputText>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <!-- formControlName="addDui" -->
                                        <p-fileUpload url="./upload" chooseLabel="Adjunte Pasaporte" accept="image/*" maxFileSize="1000000"
                                        (onSelect)="onFileSelected($event, 'adjPasaporte')"></p-fileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <!-- formControlName="addNota" -->
                                        <p-fileUpload url="./upload" chooseLabel="Adjunte credencial" accept="image/*" maxFileSize="1000000"
                                        (onSelect)="onFileSelected($event, 'adjCredencial')"></p-fileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <p-calendar [showIcon]="true" placeholder="Credencial vigente hasta" inputId="icon"
                                            formControlName="dateCredencial"></p-calendar>
                                        <small *ngIf="form.get('entidadForm.extranjero.dateCredencial')?.hasError('required') && form.get('entidadForm.extranjero.dateCredencial')?.touched"
                                            class="error">El
                                            campo es requerido</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="perExt">
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <input formControlName="pasaporte" type="text" placeholder="Ingrese su pasaporte" pInputText>
                                <small
                                    *ngIf="form.get('entidadForm.pasaporte')?.hasError('required') && form.get('entidadForm.pasaporte')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <input formControlName="nombres" type="text" placeholder="Nombres" pInputText>
                                <small
                                    *ngIf="form.get('entidadForm.nombres')?.hasError('required') && form.get('entidadForm.nombres')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <input formControlName="correo" type="email" placeholder="Ingrese su correo" pInputText>
                                <small
                                    *ngIf="form.get('entidadForm.correo')?.hasError('required') && form.get('entidadForm.correo')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-fileUpload url=" ./upload" chooseLabel="Adjunte pasaporte" accept="image/*" maxFileSize="1000000"
                                    (onSelect)="onFileSelected($event, 'adjPasaporte')"></p-fileUpload>
                                <!-- <small
                                    *ngIf="form.get('natural.imgDui')?.hasError('required') && form.get('natural.imgDui')?.touched"
                                    class="error">El
                                    campo es requerido</small> -->
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <textarea formControlName="direccion" rows="5" cols="30" placeholder="Ingrese su direccion"
                                    pInputTextarea autoResize="autoResize"></textarea>
                                <small
                                    *ngIf="form.get('entidadForm.direccion')?.hasError('required') && form.get('entidadForm.direccion')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-dropdown formControlName="tipoComprobante"
                                    placeholder="Tipo de comprobante predeterminado" [options]="tiposComprobantes"
                                    [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                                    optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                                <small
                                    *ngIf="form.get('entidadForm.tipoComprobante')?.hasError('required') && form.get('entidadForm.tipoComprobante')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="municipalidad">
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <input formControlName="nit" type="text" placeholder="Ingrese su NIT" pInputText>
                                <small
                                    *ngIf="form.get('entidadForm.nit')?.hasError('required') && form.get('entidadForm.nit')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <input formControlName="nombreEntidad" type="text" placeholder="Nombre de la entidad"
                                    pInputText>
                                <small
                                    *ngIf="form.get('entidadForm.nombreEntidad')?.hasError('required') && form.get('entidadForm.nombreEntidad')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <input formControlName="correo" type="email" placeholder="Ingrese su correo" pInputText>
                                <small
                                    *ngIf="form.get('entidadForm.correo')?.hasError('required') && form.get('entidadForm.correo')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <!-- formControlName="adjNit" -->
                                <p-fileUpload url="./upload" chooseLabel="Adjunte NIT" accept="image/*" maxFileSize="1000000"
                                (onSelect)="onFileSelected($event, 'adjNit')"></p-fileUpload>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <textarea formControlName="direccion" rows="5" cols="30" placeholder="Ingrese su direccion"
                                    pInputTextarea autoResize="autoResize"></textarea>
                                <small
                                    *ngIf="form.get('entidadForm.direccion')?.hasError('required') && form.get('entidadForm.direccion')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <p-dropdown formControlName="tipoComprobante"
                                    placeholder="Tipo de comprobante predeterminado" [options]="tiposComprobantes"
                                    [dropdownIcon]="isLoadingData ? 'pi pi-spin pi-spinner' : icon ? icon: 'pi pi-chevron-down'"
                                    optionLabel="label" optionValue="value" appendTo="body"></p-dropdown>
                                <small
                                    *ngIf="form.get('entidadForm.tipoComprobante')?.hasError('required') && form.get('entidadForm.tipoComprobante')?.touched"
                                    class="error">El campo es requerido</small>
                            </div>
                        </div>
                        <h2>Representante legal</h2>
                        <hr>
                        <div class="p-field p-grid">
                            <div class="p-col-12 p-md-12">
                                <div class="p-formgroup-inline">
                                    <div class="p-field-radiobutton">
                                        <input type="radio" class="radioButton" name="representanteG" value="salva"
                                            formControlName="representanteG" pRadioButton>
                                        <label class="radioLabel" for="">Salvadoreño</label>
                                    </div>
                                    <div class="p-field-radiobutton">
                                        <input type="radio" class="radioButton" name="representanteG" value="extra"
                                            formControlName="representanteG" pRadioButton>
                                        <label class="radioLabel" for="">Extranjero</label>
                                    </div>
                                </div>
                            </div>
                            <!-- <small
                                    *ngIf="form.get('entidadForm.tipoComprobante')?.hasError('required') && form.get('entidadForm.tipoComprobante')?.touched"
                                    class="error">El campo es requerido</small> -->
                        </div>
                        <div *ngIf="salva">
                            <div formGroupName="salvadorenio">
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <span class="p-input-icon-left">
                                            <i class="pi pi-search"></i>
                                            <input formControlName="dui" type="text" placeholder="Ingrese su DUI" pInputText>
                                        </span>
                                        <small
                                            *ngIf="form.get('entidadForm.salvadorenio.dui')?.hasError('required') && form.get('entidadForm.salvadorenio.dui')?.touched"
                                            class="error">El campo es requerido</small>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <span class="p-input-icon-right">
                                            <i class="pi pi-spin pi-spinner" *ngIf="duiGloading"></i>
                                            <input formControlName="nombres" type="text" placeholder="Ingrese sus nombres"
                                                pInputText>
                                        </span>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <span class="p-input-icon-right">
                                            <i class="pi pi-spin pi-spinner" *ngIf="duiGloading"></i>
                                            <input formControlName="apellidos" type="text" placeholder="Ingrese sus apellidos"
                                                pInputText>
                                        </span>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <!-- formControlName="addDui" -->
                                        <p-fileUpload url="./upload" chooseLabel="Adjunte DUI" accept="image/*" maxFileSize="1000000"
                                        (onSelect)="onFileSelected($event, 'adjDui')"></p-fileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <!-- formControlName="addNota" -->
                                        <p-fileUpload url="./upload" chooseLabel="Adjunte credencial" accept="image/*" maxFileSize="1000000"
                                        (onSelect)="onFileSelected($event, 'adjCredencial')"></p-fileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <p-calendar [showIcon]="true" placeholder="Credencial vigente hasta" inputId="icon"
                                            formControlName="dateCredencial"></p-calendar>
                                        <small *ngIf="form.get('entidadForm.salvadorenio.dateCredencial')?.hasError('required') && form.get('entidadForm.salvadorenio.dateCredencial')?.touched"
                                            class="error">El
                                            campo es requerido</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="extra">
                            <div formGroupName="extranjero">
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <input formControlName="pasaporte" type="text" placeholder="Ingrese su Pasaporte" pInputText>
                                        <small
                                            *ngIf="form.get('entidadForm.extranjero.pasaporte')?.hasError('required') && form.get('entidadForm.extranjero.pasaporte')?.touched"
                                            class="error">El campo es requerido</small>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <input formControlName="nombres" type="text" placeholder="Ingrese sus nombres"
                                            pInputText>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <input formControlName="apellidos" type="text" placeholder="Ingrese sus apellidos"
                                            pInputText>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <!-- formControlName="adjPasaporte" -->
                                        <p-fileUpload url="./upload" chooseLabel="Adjunte Pasaporte" maxFileSize="1000000"
                                        (onSelect)="onFileSelected($event, 'adjPasaporte')"></p-fileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <!-- formControlName="adjCredencial" -->
                                        <p-fileUpload url="./upload" chooseLabel="Adjunte credencial" maxFileSize="1000000"
                                        (onSelect)="onFileSelected($event, 'adjCredencial')"></p-fileUpload>
                                    </div>
                                </div>
                                <div class="p-field p-grid">
                                    <div class="p-col-12 p-md-12">
                                        <p-calendar [showIcon]="true" placeholder="Credencial vigente hasta" inputId="icon"
                                            formControlName="dateCredencial"></p-calendar>
                                        <small *ngIf="form.get('entidadForm.extranjero.dateCredencial')?.hasError('required') && form.get('entidadForm.extranjero.dateCredencial')?.touched"
                                            class="error">El
                                            campo es requerido</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- [disabled]="form.invalid" -->
            <div class="p-d-flex p-jc-center p-col-12">
                <button pButton label="Guardar" type="submit"
                    class="p-col-12 p-md-6 p-lg-5 p-button-outlined p-button-success"></button>
            </div>
        </form>
    </p-card>
  </div>

  <p-dialog [(visible)]="displayModal" modal="true" [closable]="false" header=" " [style]="{width: '400px'}">
    <div class="p-d-flex p-ai-center p-jc-center p-flex-column">
      <i class="pi pi-check-circle" style="font-size: 4em; color: #4caf50;"></i>
      <h3 class="p-mt-3">Entidad creada con éxito</h3>
      <button pButton label="Continuar" class="p-mt-3" (click)="continuar()"></button>
    </div>
  </p-dialog>